module.exports = __webpack_public_path__ + "assets/img/352811c3c31c3b84be4c0a55fc8c7842.svg";